/* ★ SUIS CAPTION KAD — TikTok / FB (pilihan A, lakaran user 2026-09-27).
 *
 * Menggantikan butang kecil "FB" (16 Sept) yang hanya ada pada kotak caption Set 1.
 * Suis kini ada pada SETIAP kotak caption kad (Set 1 / 2 / 3 + kad N-scene) dan tekan pada
 * mana-mana set menukar KETIGA-TIGA set kad itu serentak — keadaan disimpan ikut KAD
 * (`capTabFb` dalam WorkspaceView, kunci product.id), bukan ikut set.
 *
 * ⛔ PAPARAN SAHAJA. Tidak disimpan (refresh = kembali TikTok) dan TIDAK mengubah apa yang
 *    robot post. Mod FB memapar caption yang BETUL-BETUL akan dipost ke Facebook:
 *    lalai = caption TikTok, atau caption FB yang pelanggan simpan, atau kosong kalau
 *    pelanggan sengaja mengosongkannya. Caption FB diedit dalam modal Edit prompts sahaja.
 *    Peraturan + data: utils/captionKad.js.
 *
 * Rupa lama = kelas Tailwind di sini; rupa v3.9 = SuisCaptionKad.css (dipagar .sesaat-kad-v39).
 * `T` datang daripada pemanggil (WorkspaceView — dua rupa), jangan useT.
 */
import './SuisCaptionKad.css';

export default function SuisCaptionKad({ fb, onTukar, T }) {
    const tajuk = T('ws.caption.suis', 'Tukar paparan caption TikTok / Facebook');
    const pil = (v, teks) => {
        const on = v === fb;
        return (
            <button
                type="button"
                aria-pressed={on}
                onClick={(e) => { e.stopPropagation(); if (!on) onTukar(v); }}
                className={`scap-pil px-1.5 rounded-sm text-[9px] font-bold leading-[14px] transition-colors ${on
                    ? 'scap-pil--on bg-slate-700 text-white dark:bg-slate-200 dark:text-slate-900'
                    : 'text-slate-400 hover:text-slate-600 dark:hover:text-slate-300'}`}
            >{teks}</button>
        );
    };
    return (
        <span
            role="group"
            aria-label={tajuk}
            title={tajuk}
            className="scap-suis inline-flex items-center gap-px p-px rounded border border-slate-200 dark:border-slate-700"
        >
            {pil(false, 'TikTok')}
            {pil(true, 'FB')}
        </span>
    );
}
